import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Versione ")
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "1.4", -1)
const _hoisted_7 = { class: "ion-padding-horizontal ion-margin-top" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Forza aggiornamento ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Logout ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _createVNode("p", null, _toDisplayString($setup.user.users_first_name) + " " + _toDisplayString($setup.user.users_last_name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _createVNode("p", null, _toDisplayString($setup.user.users_email), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_ion_button, {
              color: "primary",
              fill: "solid",
              expand: "block",
              onClick: $setup.updateApp,
              class: "ion-margin-bottom"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_ion_button, {
              color: "danger",
              fill: "solid",
              expand: "block",
              onClick: $setup.logOut
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}